import React from 'react';
import {Row, Col, Button} from 'antd';
import {
    ArticleHeader,
    ArticleParagraph, BlueText, FeatureCard, LandingPageHeader, LandingPageSubHeader,
    PinkText,
    SectionHeader,
    SectionSubHeader,
    SectionText
} from "../../../components/DesignSystem/Articles/Articles";
import {useHistory} from "react-router-dom";
import {Spacer} from "../../../components/DesignSystem/Spacer/Spacer";
import {FAQ} from "./FAQ";

export const LandingPage = () => {

    const history = useHistory();

    const features = [
        {icon: "🧩", title: "Simple Usage", desc: "Designed to be intuitive — no steep learning curve."},
        {icon: "🔍", title: "Filter Data", desc: "Quickly slice and dice CSV, Excel, JSON, Parquet, and more."},
        {icon: "🧹", title: "Clean Data", desc: "Remove duplicates, fix formats, and standardize your data."},
        {icon: "📤", title: "Export Data", desc: "Export to CSV, Excel, JSON, Parquet, or TSV effortlessly."},
        {icon: "🤖", title: "AI Data Analysis", desc: "Let AI give you insights and summarize your dataset."},
        {icon: "🧠", title: "AI Filtering", desc: "Use natural language to ask the AI to filter your data."}
    ];

    return <Row align={"center"} style={{backgroundColor: 'white'}} gutter={[16, 40]}>
        <Col sm={16} style={{textAlign: 'center'}}>
            <Spacer size={"large"}/>
            <Spacer size={"large"}/>
            <LandingPageHeader>Turn your <BlueText>data</BlueText> into meaningful <PinkText>insights</PinkText></LandingPageHeader>
            <LandingPageSubHeader>Upload your data and get <BlueText>instant insights</BlueText> — no setup, no delays,
                just <PinkText>results.</PinkText></LandingPageSubHeader>
            <Spacer size={"large"}/>
            <div style={{padding: '20px'}}>
                <Button type="primary" size="large" style={{width: '150px'}} onClick={() => history.push("/sign-up")}>Get Started</Button>
                &nbsp;&nbsp;
                <Button size="large" style={{paddingRight: '20px', width: '150px'}} onClick={() => history.push("/contact-sales")}>Request
                    Demo</Button>
            </div>
            <Spacer size={"large"}/>
            <Spacer size={"large"}/>
        </Col>
        {/*<Col sm={16}>*/}
        {/*    <Spacer size={"large"}/>*/}
        {/*    <SectionHeader>Get started in seconds</SectionHeader>*/}
        {/*    <SectionSubHeader>Understand <BlueText>your data</BlueText> in <PinkText>few minutes</PinkText></SectionSubHeader>*/}
        {/*    <Row gutter={[16, 16]}>*/}
        {/*        {features.map((feature, index) => (*/}
        {/*            <Col key={index} sm={8} style={{textAlign: 'center'}}>*/}
        {/*                <h3>{feature.icon}</h3>*/}
        {/*                <h4>{feature.title}</h4>*/}
        {/*                <p>{feature.desc}</p>*/}
        {/*            </Col>*/}
        {/*        ))}*/}
        {/*    </Row>*/}
        {/*</Col>*/}
        <Col sm={16} id={"features"}>
            <SectionHeader>DATA VIEWING</SectionHeader>
            <SectionSubHeader>Sometimes you just want to <PinkText>view your data</PinkText>
            </SectionSubHeader>
            <SectionText>
                Browse, sort, and filter your data with a beautiful, responsive table view.</SectionText>

            <FeatureCard title={"Instant Loading"}
                         desc="View millions of rows without waiting. Our virtual scrolling technology loads only what you need, when you need it."/>
            <FeatureCard title={"Smart Filtering"}
                         desc="Filter by any column with intelligent type detection. Numbers, dates, text - we've got you covered."/>
            <FeatureCard title={"Quick Sorting"}
                         desc="Sort by any column with a single click. Multi-column sorting for complex data organization."/>
            <Spacer size={"large"}/>
            <Spacer size={"large"}/>
        </Col>
        <Col sm={16}>
            <SectionHeader>CONVERSIONS</SectionHeader>
            <SectionSubHeader>Convert data <PinkText>lightning fast</PinkText></SectionSubHeader>
            <SectionText>
                Transform your data between formats in seconds, whether it's one file or thousands.
            </SectionText>

            <FeatureCard title={"Format Freedom"}
                         desc="Convert between CSV, JSON, Parquet, Excel, and more. No complicated settings - just pick source and destination formats."/>
            <FeatureCard title={"Smart Defaults"}
                         desc="Automatic type detection and intelligent defaults make conversion a breeze. Complex data structures? No problem."/>
            <Spacer size={"large"}/>
            <Spacer size={"large"}/>
        </Col>

        <Col sm={16} id={"faq"}>
            <FAQ/>
            <Spacer size={"large"}/>
            <Spacer size={"large"}/>
        </Col>
    </Row>

}